// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error.error-6 .error-title{font-size:5rem!important}@media(min-width:768px){.error.error-6 .error-title{font-size:10rem!important}}", ""]);
// Exports
module.exports = exports;
